// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitoring-type {
  width: 160px;
}

.monitoring-type .dropdown-menu {
  padding: 0px;
  top: -40px;
  z-index: 999;
  transform: translate3d(0px, -3px, 0px) !important;
  border-radius: 0.5rem;
  border: 1px solid #e4e7f0;
}

.monitoring-type button {
  color: #222735;
  font-size: 14px;
  border-radius: 0.5rem;
}

.monitoring-type button:focus,
.monitoring-type button:active {
  box-shadow: none !important;
  border-color: #E4E7F0;
}

.monitoring-type li {
  color: #636A7D;
  background: #ffffff;
  font-size: 1rem;
  padding: 0.75rem 1rem;
}

.monitoring-type li.active,
.monitoring-type li:hover {
  background: #E4E7F0;
  cursor: pointer;
}

.monitoring-type button {
  background-repeat: no-repeat;
  background-position: 96% 50%;
  text-align: left;
  background-color: #f4f6fa;
}

.monitoring-type button.disabled {
  color: #a7b2cd;
  background: #f4f6fa;
  border: 1px solid #e4e7f0;
  background-repeat: no-repeat;
  background-position: 96% 50%;
  text-align: left;
}

.monitoring-checkbox .custom-checkbox label:before {
  top: -1px;
}

.monitoring-checkbox .custom-checkbox label:after {
  top: 3px;
}

.custom-checkbox label.disabled {
  color: #a7b2cd;
}

.custom-checkbox label.disabled:before {
  border-color: #a7b2cd;
}

.p-relative {
  position: relative;
}

.progress {
  height: 4px !important;
  border-radius: 1rem !important;
  position: absolute;
  left: 0;
  bottom: -8px;
  right: 0;
}

.progress .bg-green {
  background-color: #11BC97;
}

.upload-file .progress.invisible {
  opacity: 0;
  visibility: hidden;
}

.upload-file .progress.visible {
  opacity: 1;
  visibility: visible;
}

.upload-file input[type=file] {
  opacity: 0;
  z-index: 999;
  position: absolute;
  bottom: 0;
  cursor: pointer;
}

.upload-file button {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 47px;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #ffffff !important;
}

.batchJobsListing li {
  border: 1px solid #E4E7F0;
  border-radius: 0.75rem;
  margin-top: 1rem;
  cursor: pointer;
  padding: 1rem !important;
}

.batchJobsListing li h6 {
  color: #222735;
  font-weight: 600;
  font-size: 15px;
}

.job-status,
.batchJobsListing li p {
  font-size: 13px;
  margin-bottom: 0;
}

.batchJobsListing li p {
  color: #222735;
}

.batch-job-col span {
  font-size: 12px;
  margin-bottom: 16px;
  display: block;
  color: #636A7D;
}

.batchJobsListing li .right-fields {
  border-left: 1px solid #E4E7F0;
  padding-left: 16px;
  flex: 0 0 80%;
}

.job-entities .company {
  width: 200px;
}

.tool-tip {
  position: absolute;
  z-index: 99999999999;
  color: #ffffff;
  background: #222735 !important;
  padding: 8px 12px;
  top: -60px !important;
  left: 16px !important;
  width: 220px;
  border-radius: 0.5rem;
  opacity: 0;
  visibility: hidden;
}

.tool-tip::after {
  position: absolute;
  background-color: #222735;
  height: 14px;
  width: 14px;
  content: "";
  transform: rotate(45deg);
  left: 24px;
}

.tag:hover .tool-tip {
  opacity: 0.85;
  visibility: visible;
}

.result-list li .icon {
  transition: all 0.2s ease;
}

.result-list li.opened .icon {
  transform: rotate(-180deg);
}

.t-row {
  list-style: none;
  margin: 0;
  padding: 0;
  display: table;
  width: 100%;
}

.t-row span:first-child {
  width: 16%;
  min-width: 16%;
}

.t-row span:last-child {
  width: 6%;
  min-width: 6%;
}

.t-row span {
  font-size: 13px;
  width: 15.5%;
  min-width: 15.5%;
  padding: 1rem 0.5rem;
  text-align: left;
  display: table-cell;
  vertical-align: middle;
}

.result-summary .col:first-child {
  text-align: right;
}

.result-summary {
  width: 100%;
  padding: 2rem 0;
}

.result-summary p {
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  height: 20px;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.result-summary .internal-info {
  min-width: 150px;
}

.internal-info p {
  width: 200px;
}

.result-summary .badge {
  margin-bottom: 1rem;
  display: block;
  width: max-content;
  line-height: 1.5;
}

.emptySpace {
  opacity: 0;
}

.result-summary > div:first-child {
  min-width: 95px;
}

.result-summary > div:nth-child(2) {
  margin-right: 2.1rem;
}

.result-summary .badge {
  width: 103px;
  background-color: #ffffff;
}

.result-summary .badge.exact {
  border: 1px solid #E66A8B;
  color: #ffffff;
  background-color: #E66A8B;
}

.result-summary .badge.partial {
  border: 1px solid #FB8C3D;
}

.result-summary .badge.notavailable {
  width: auto !important;
  border: none !important;
  border-radius: 0 !important;
}

.result-summary .badge.different {
  border: 1px solid #E66A8B;
  color: #E66A8B;
}

.batch-more {
  position: relative;
  display: block;
  opacity: 0;
  visibility: hidden;
}

.batch-more-content {
  display: none;
  position: absolute;
  right: -18px;
  z-index: 999;
  width: 320px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #E4E7F0;
  top: -34px;
}

.batch-more:hover .batch-more-content {
  display: block;
}

.batch-more-content > div {
  display: block;
  padding: 8px;
}

.batch-more-content > div img:first-child {
  margin-right: 8px;
}

.batch-more-content .chevron-down {
  margin-left: 16px;
  transition: all 0.2s ease;
}

.batch-more-content > div:last-child {
  border-top: 1px solid #E4E7F0;
  color: #E66A8B !important;
}

.frequency-options {
  padding: 4px 40px !important;
}

.frequency-options-hide {
  display: none !important;
}

.frequency-options-show {
  display: block;
}

.form__radio-input {
  display: none;
}

.form__label-radio {
  font-size: 14px;
  cursor: pointer;
  padding-left: 2rem;
  position: relative;
}

.form__radio-button {
  height: 14px;
  width: 14px;
  border: 2px solid #11bc97;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 4px;
}

.form__radio-button::after {
  content: "";
  display: block;
  height: 7px;
  width: 7px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #55c57a;
  opacity: 0;
  transition: opacity 0.2s;
}

.form__radio-input:checked ~ .form__label-radio .form__radio-button::after {
  opacity: 1;
}

.frequency-options-show-parent {
  background-color: #E4E7F0;
}

.frequency-options-show-parent .chevron-down {
  transform: rotate(-180deg);
}

.job-batch-status-icon {
  width: 24px;
}

.job-status-content {
  margin-top: 2px;
}

.job-status-content h6 {
  width: 170px;
}

.summary-content {
  position: relative;
  max-height: 550px;
  overflow: hidden;
}

.summary-content::after {
  position: absolute;
  background: rgb(255, 255, 255);
  background: linear-gradient(0deg, rgb(255, 255, 255) 30%, rgba(255, 255, 255, 0) 100%);
  opacity: 0.5;
  content: "";
  bottom: 0;
  width: 100%;
  height: 160px;
}

.batchJobsListing li:hover .batch-more {
  opacity: 1;
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/styles/batchScreen.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;EACA,UAAA;EACA,YAAA;EACA,iDAAA;EACA,qBAAA;EACA,yBAAA;AADF;;AAIA;EACE,cCEqB;EDDrB,eAAA;EACA,qBAAA;AADF;;AAIA;;EAEE,2BAAA;EACA,qBCVgB;ADSlB;;AAIA;EACE,cCZoB;EDapB,mBC7BY;ED8BZ,eAAA;EACA,qBAAA;AADF;;AAIA;;EAEE,mBCtBgB;EDuBhB,eAAA;AADF;;AAIA;EACE,4BAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,4BAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;AADF;;AAIA;EACE,QAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;AADF;;AAIA;EACE,yBCpFW;ADmFb;;AAIA;EACE,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,UAAA;EACA,mBAAA;AADF;;AAIA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AADF;;AAIA;;EAEE,oCAAA;AADF;;AAIA;EACE,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;AADF;;AAIA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;;EAEE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,cCnIoB;ADkItB;;AAIA;EACE,8BAAA;EACA,kBAAA;EACA,aAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,oBAAA;EACA,cCnKY;EDoKZ,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,UAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EAGE,yBAAA;AADF;;AAIA;EAGE,0BAAA;AADF;;AAIA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AADF;;AAIA;EACE,UAAA;EACA,cAAA;AADF;;AAIA;EACE,SAAA;EACA,aAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,YAAA;EACA,yBCpRY;ADmRd;;AAIA;EACE,yBAAA;EAEA,cC1RY;ED2RZ,yBCrRU;ADmRZ;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,yBAAA;EAEA,cCrSU;ADkSZ;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBC3TY;ED4TZ,kBAAA;EACA,yBAAA;EAEA,UAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,YAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,6BAAA;EACA,yBAAA;AAJF;;AAOA;EACE,4BAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAMA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAHF;;AAKA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAFF;;AAIA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,UAAA;EACA,wBAAA;AADF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,yBC7XgB;AD6XlB;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,8BAAA;EACA,sFAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,UAAA;EACA,mBAAA;AAAF","sourcesContent":["@import './colors';\n\n.monitoring-type {\n  width: 160px;\n}\n\n.monitoring-type .dropdown-menu {\n  padding: 0px;\n  top: -40px;\n  z-index: 999;\n  transform: translate3d(0px, -3px, 0px) !important;\n  border-radius: 0.5rem;\n  border: 1px solid #e4e7f0;\n}\n\n.monitoring-type button {\n  color: $color-monoIntenseGrey;\n  font-size: 14px;\n  border-radius: 0.5rem;\n}\n\n.monitoring-type button:focus,\n.monitoring-type button:active {\n  box-shadow: none !important;\n  border-color: $color-normalGrey;\n}\n\n.monitoring-type li {\n  color: $color-monoNormalGrey;\n  background: $color-white;\n  font-size: 1rem;\n  padding: 0.75rem 1rem;\n}\n\n.monitoring-type li.active,\n.monitoring-type li:hover {\n  background: $color-normalGrey;\n  cursor: pointer;\n}\n\n.monitoring-type button {\n  background-repeat: no-repeat;\n  background-position: 96% 50%;\n  text-align: left;\n  background-color: #f4f6fa;\n}\n\n.monitoring-type button.disabled {\n  color: #a7b2cd;\n  background: #f4f6fa;\n  border: 1px solid #e4e7f0;\n  background-repeat: no-repeat;\n  background-position: 96% 50%;\n  text-align: left;\n}\n\n.monitoring-checkbox .custom-checkbox label:before {\n  top: -1px;\n  // border-color: #A7B2CD;\n}\n.monitoring-checkbox .custom-checkbox label:after {\n  top: 3px;\n}\n\n.custom-checkbox label.disabled {\n  color: #a7b2cd;\n}\n\n.custom-checkbox label.disabled:before {\n  border-color: #a7b2cd;\n}\n\n.p-relative {\n  position: relative;\n}\n\n.progress {\n  height: 4px !important;\n  border-radius: 1rem !important;\n  position: absolute;\n  left: 0;\n  bottom: -8px;\n  right: 0;\n}\n\n.progress .bg-green {\n  background-color: $color-green;\n}\n\n.upload-file .progress.invisible {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.upload-file .progress.visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.upload-file input[type='file'] {\n  opacity: 0;\n  z-index: 999;\n  position: absolute;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.upload-file button {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  height: 47px;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: $color-white !important;\n}\n\n.batchJobsListing li {\n  border: 1px solid $color-normalGrey;\n  border-radius: 0.75rem;\n  margin-top: 1rem;\n  cursor: pointer;\n  padding: 1rem !important;\n}\n\n.batchJobsListing li h6 {\n  color: #222735;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.job-status,\n.batchJobsListing li p {\n  font-size: 13px;\n  margin-bottom: 0;\n}\n\n.batchJobsListing li p {\n  color: #222735;\n}\n\n.batch-job-col span {\n  font-size: 12px;\n  margin-bottom: 16px;\n  display: block;\n  color: $color-monoNormalGrey;\n}\n\n.batchJobsListing li .right-fields {\n  border-left: 1px solid $color-normalGrey;\n  padding-left: 16px;\n  flex: 0 0 80%;\n}\n\n.job-entities .company {\n  width: 200px;\n}\n\n.tool-tip {\n  position: absolute;\n  z-index: 99999999999;\n  color: $color-white;\n  background: #222735 !important;\n  padding: 8px 12px;\n  top: -60px !important;\n  left: 16px !important;\n  width: 220px;\n  border-radius: 0.5rem;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.tool-tip::after {\n  position: absolute;\n  background-color: #222735;\n  height: 14px;\n  width: 14px;\n  content: '';\n  transform: rotate(45deg);\n  left: 24px;\n}\n\n.tag:hover .tool-tip {\n  opacity: 0.85;\n  visibility: visible;\n}\n\n.result-list li .icon {\n  -moz-transition: all 0.2s ease;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\n.result-list li.opened .icon {\n  -webkit-transform: rotate(-180deg);\n  -moz-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n\n.t-row {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: table;\n  width: 100%;\n}\n\n.t-row span:first-child {\n  width: 16%;\n  min-width: 16%;\n}\n\n.t-row span:last-child {\n  width: 6%;\n  min-width: 6%;\n}\n\n.t-row span {\n  font-size: 13px;\n  width: 15.5%;\n  min-width: 15.5%;\n  padding: 1rem 0.5rem;\n  text-align: left;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.result-summary .col:first-child {\n  text-align: right;\n}\n\n.result-summary {\n  width: 100%;\n  padding: 2rem 0;\n}\n\n.result-summary p {\n  font-size: 13px;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  height: 20px;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.result-summary .internal-info {\n  min-width: 150px;\n}\n\n.internal-info p {\n  width: 200px;\n}\n\n.result-summary .badge {\n  margin-bottom: 1rem;\n  display: block;\n  width: max-content;\n  line-height: 1.5;\n}\n\n.emptySpace {\n  opacity: 0;\n}\n\n.result-summary > div:first-child {\n  min-width: 95px;\n}\n\n.result-summary > div:nth-child(2) {\n  margin-right: 2.1rem;\n}\n\n.result-summary .badge {\n  width: 103px;\n  background-color: $color-white;\n}\n\n.result-summary .badge.exact {\n  border: 1px solid $color-pink;\n  // box-shadow: 0px 2px 8px rgba(230, 106, 139, 0.7);\n  color: $color-white;\n  background-color: $color-pink;\n}\n\n.result-summary .badge.partial {\n  border: 1px solid $color-yellow;\n}\n\n.result-summary .badge.notavailable {\n  width: auto !important;\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.result-summary .badge.different {\n  border: 1px solid $color-pink;\n  // box-shadow: 0px 2px 8px rgba(230, 106, 139, 0.7);\n  color: $color-pink;\n}\n\n.batch-more {\n  position: relative;\n  display: block;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.batch-more-content {\n  display: none;\n  position: absolute;\n  right: -18px;\n  z-index: 999;\n  width: 320px;\n  background: $color-white;\n  border-radius: 8px;\n  border: 1px solid $color-normalGrey;\n  // padding: 8px;\n  top: -34px;\n}\n\n.batch-more:hover .batch-more-content {\n  display: block;\n}\n\n.batch-more-content > div {\n  display: block;\n  padding: 8px;\n}\n\n.batch-more-content > div img:first-child {\n  margin-right: 8px;\n}\n\n.batch-more-content .chevron-down {\n  margin-left: 16px;\n  transition: all 0.2s ease;\n}\n\n.batch-more-content > div:last-child {\n  border-top: 1px solid $color-normalGrey;\n  color: $color-pink !important;\n}\n\n.frequency-options {\n  padding: 4px 40px !important;\n}\n\n.frequency-options-hide {\n  display: none !important;\n}\n\n.frequency-options-show {\n  display: block;\n}\n\n.form__radio-input {\n  display: none;\n}\n.form__label-radio {\n  font-size: 14px;\n  cursor: pointer;\n  padding-left: 2rem;\n  position: relative;\n}\n.form__radio-button {\n  height: 14px;\n  width: 14px;\n  border: 2px solid #11bc97;\n  border-radius: 50%;\n  display: inline-block;\n  position: absolute;\n  left: 0;\n  top: 4px;\n}\n.form__radio-button::after {\n  content: '';\n  display: block;\n  height: 7px;\n  width: 7px;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #55c57a;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n.form__radio-input:checked ~ .form__label-radio .form__radio-button::after {\n  opacity: 1;\n}\n\n.frequency-options-show-parent {\n  background-color: $color-normalGrey;\n}\n\n.frequency-options-show-parent .chevron-down {\n  transform: rotate(-180deg);\n}\n\n.job-batch-status-icon {\n  width: 24px;\n}\n\n.job-status-content {\n  margin-top: 2px;\n}\n\n.job-status-content h6 {\n  width: 170px;\n}\n\n.summary-content {\n  position: relative;\n  max-height: 550px;\n  overflow: hidden;\n}\n\n.summary-content::after {\n  position: absolute;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(0deg, rgb(255, 255, 255) 30%, rgb(255 255 255 / 0%) 100%);\n  opacity: 0.5;\n  content: '';\n  bottom: 0;\n  width: 100%;\n  height: 160px;\n}\n\n.batchJobsListing li:hover .batch-more {\n  opacity: 1;\n  visibility: visible;\n}\n","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
